'use strict'

export const store = {
  authn: false,
  accountAvailable: false,
  account: {},
  permissionsAvailable: false,
  permissions: {}
}
